// hooks/useCometChatInit.ts
import { useEffect, useState } from 'react';
import { CometChatUIKit, UIKitSettingsBuilder } from "@cometchat/chat-uikit-react";
import { setupLocalization } from '../../../CometChat/utils/utils';
import { useGetAuthTokenMutation } from '../../../store/services/cometchat';


export const COMETCHAT_CONSTANTS = {
    APP_ID: process.env.REACT_APP_CC_APP_ID || "",
    REGION: process.env.REACT_APP_CC_REGION || "",
    ADMIN_USER_ID: "cometchat-admin"
};



export const useCometChatInit = () => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [getAuthToken] = useGetAuthTokenMutation();

    useEffect(() => {
        const initializeCometChat = async () => {
            try {

                const uiKitSettings = new UIKitSettingsBuilder()
                    .setAppId(COMETCHAT_CONSTANTS.APP_ID)
                    .setRegion(COMETCHAT_CONSTANTS.REGION)
                    .subscribePresenceForAllUsers()
                    .build();

                await CometChatUIKit.init(uiKitSettings);
                setupLocalization();

                const user = await CometChatUIKit.getLoggedinUser();
                if (!user) {
                    const authTokenResponse = await getAuthToken(COMETCHAT_CONSTANTS.ADMIN_USER_ID).unwrap();
                    const authToken = authTokenResponse.data.authToken
                    const loggedUser = await CometChatUIKit.loginWithAuthToken(
                        authToken
                    );

                    console.log("[CometChat] Login Successful:", loggedUser);
                } else {
                    console.log("[CometChat] User already logged in:", user);
                }

                setIsInitialized(true);
            } catch (err) {
                console.error("[CometChat] Initialization/Login Failed:", err);
                setError(err instanceof Error ? err : new Error('Unknown error'));
                setIsInitialized(true); // Still set to true to render the app
            }
        };

        initializeCometChat();
    }, [getAuthToken]);

    return { isInitialized, error };
};